import { render, staticRenderFns } from "./choosePersonDialog.vue?vue&type=template&id=36719147&scoped=true&"
import script from "./choosePersonDialog.vue?vue&type=script&lang=js&"
export * from "./choosePersonDialog.vue?vue&type=script&lang=js&"
import style0 from "./choosePersonDialog.vue?vue&type=style&index=0&id=36719147&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36719147",
  null
  
)

export default component.exports